"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5.6442 7.0515l1.4071-1.4072 2.1213 2.1213-1.4071 1.4072zM11 1h2v6h-2zM16.2418 14.834l2.1213 2.1214-1.4072 1.4071-2.1213-2.1213zM14.8341 7.7586l2.1213-2.1213 1.4071 1.4071-2.1213 2.1213zM9.1658 16.2415l-2.1213 2.1213-1.4071-1.4071 2.1212-2.1213zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM11 17h2v6h-2zM1 11h6v2H1zM17 11h6v2h-6z"
}))), 'FlareTwoTone');

exports.default = _default;